import { Stack, Typography } from '@mui/material';

import LargeCard from '@/components/LargeCard';
import {
  INCIDENT_RESPONSE_PHONE_NUMBER,
  INCIDENT_RESPONSE_PHONE_NUMBER_HREF,
  SOC_EMAIL,
  SOC_PHONE_NUMBER,
  SOC_PHONE_NUMBER_HREF
} from '@/constants/common';

import useStyles from './PonduranceContactInfo.styles';

const PonduranceContactInfo = () => {
  const { classes } = useStyles();
  return (
    <LargeCard title="Pondurance Contact Information" style={{ flex: 1 }}>
      <Stack spacing={2}>
        <div>
          <Typography variant="h6">Security Operations Center</Typography>
          <Typography sx={{ color: 'primary.main' }} variant="body1">
            <a className={classes.linkText} href={`mailto:${SOC_EMAIL}`}>
              {SOC_EMAIL}
            </a>
          </Typography>
          <Typography sx={{ color: 'primary.main' }} variant="body1">
            <a className={classes.linkText} href={SOC_PHONE_NUMBER_HREF}>
              {SOC_PHONE_NUMBER}
            </a>
          </Typography>
        </div>
        <div>
          <Typography variant="h6">Incident Response Line</Typography>
          <Typography sx={{ color: 'error.main' }} variant="body1">
            <a
              className={classes.linkText}
              href={INCIDENT_RESPONSE_PHONE_NUMBER_HREF}
            >
              {INCIDENT_RESPONSE_PHONE_NUMBER}
            </a>
          </Typography>
        </div>
      </Stack>
    </LargeCard>
  );
};

export default PonduranceContactInfo;
